module.exports = "module.exports = __webpack_public_path__ + &quot;media/images/icon/bus2-290e29d3fd4d023db3881e577122a205.svg&quot;;"